export default __webpack_public_path__ + "static/3-1a97743e2f0aba442a0a08267bde4167.png";